import { useEffect } from 'react';
import { throwErrorForDev } from '@zocdoc-frontend-common/utils-react';
import {
    isProductionBuild,
    isNullOrEmptyString,
} from '@zocdoc-mezzanine/internal-shared';

/**
 * Logs a warning or throws an error if one or more props are invalid.
 * This will no-op on Production builds.
 * @param {*} props - props to validate
 */
export default function usePropValidation({
    onClick,
    beforeClick,
    href,
    type,
}) {
    useEffect(() => {
        if (isProductionBuild()) {
            return;
        }

        if (
            (type === 'submit' || type === 'reset') &&
            typeof href === 'string'
        ) {
            throwErrorForDev(
                'Href should not be defined for reset or submit buttons'
            );
        }

        if (typeof onClick === 'function' && typeof href === 'string') {
            throwErrorForDev(
                'You cannot have both onClick and href in the same button'
            );
        }

        if (
            typeof onClick === 'undefined' &&
            isNullOrEmptyString(href) &&
            type !== 'reset' &&
            type !== 'submit'
        ) {
            throwErrorForDev(
                'You should have either valid onClick or href in a button'
            );
        }

        if (
            typeof onClick === 'function' &&
            typeof beforeClick === 'function'
        ) {
            throwErrorForDev(
                'The beforeClick prop is only used for links. Consider consolidating the beforeClick into your onClick handler instead.'
            );
        }
    }, [onClick, beforeClick, href, type]);
}
